import { useSelector } from 'react-redux';
import { selectLogoUrl, selectInAppLogoUrl, selectAppName, isFeatureAllowed } from '../store/slices/tenantSlice';

/**
 * useTenantBranding
 *
 * Single source of truth for tenant-specific branding and feature gating.
 *
 * Usage:
 *   const { logoUrl, appName, checkFeature } = useTenantBranding();
 *   const canSeePeople = checkFeature('People');
 */
export function useTenantBranding() {
    const loginLogoUrl = useSelector(selectLogoUrl);
    const inAppLogoUrl = useSelector(selectInAppLogoUrl);
    const appName = useSelector(selectAppName);

    /**
     * Returns true when the named feature is allowed by the current
     * tenant config, or when no config has been loaded yet (fail-open).
     */
    const checkFeature = useSelector(
        (state: any) =>
            (featureName: string) =>
                isFeatureAllowed(state, featureName)
    );

    return { loginLogoUrl, inAppLogoUrl, logoUrl: loginLogoUrl, appName, checkFeature };
}
